import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import { useSEO } from "@/hooks/useSEO";
import { seoData } from "@/data/seoData";
import Hero from "./components/Hero";
import LegalContent from "./components/LegalContent";

export default function MentionsLegales() {
  useSEO(seoData.mentionsLegales);
  return (
    <>
      <Header />
      <main>
        <Hero />
        <LegalContent />
      </main>
      <Footer />
    </>
  );
}